export const NUMBERS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']

export const OPERATORS = ['+', '-', '*', '/', '(', ')']

export const COMPARISON_OPERATORS = ['>', '<', '=']

export const FORMULAS = [
  {
    key: 'countifs',
    value: 'COUNTIFS',
    tooltipTitle: 'Click to change function to COUNTIFS',
    description: 'Counting values depending on multiple criteria',
    formula: 'COUNTIFS(initial_range : end_range; value)',
  },
  {
    key: 'if',
    value: 'IF',
    tooltipTitle: 'Click to change function to IF',
    description: 'Returns the value depending on the logical expression',
    formula: 'IF(condition; when_true; when_false)',
  },
  {
    key: 'agedetail',
    value: 'AGEDETAIL',
    tooltipTitle: 'Click to change function to AGE',
    description: 'Returns the value depending on the logical expression',
    formula: 'AGEDETAIL(date_field, only_number, include_months)',
  },
]
